import React from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';

import { TableRow, TableCell, Box } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import { Create } from '@material-ui/icons';

import CmtObjectSummary from '@coremat/CmtObjectSummary';
import CmtAvatar from '@coremat/CmtAvatar';

import getProfileImage from '@jumbo/utils/hooks/getProfileImage';

const useStyles = makeStyles(theme => ({
  tableRowRoot: {
    position: 'relative',
    transition: 'all .2s',
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    '&:hover, &.active': {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      '& $tableCellRoot, & $titleRoot': {
        color: theme.palette.text.primary,
      },
      '& $showContent': {
        width: 0,
      },
      '& $hideContent': {
        transform: 'translateX(0)',
        width: '100%',
      },
    },
    '&:last-child': {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: 'transparent',
    },
    '&.collapse-table-row': {
      borderTop: '0 none',
      '& $tableCellRoot': {
        padding: 0,
      },
    },
    '&.active': {
      borderTop: '0 none',
      '&:hover': {
        transform: 'none',
        boxShadow: 'none',
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: '0 none',
    position: 'relative',
    '&:first-child': {
      paddingLeft: 24,
    },
    '&:last-child': {
      textAlign: 'right',
      paddingRight: 24,
    },
  },
  tableCellFirst: {
    width: '50%',
  },
  tableCellSecond: {
    width: '25%',
  },
  tableCellHideShow: {
    width: '25%',
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  hideShowContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
  },
  showContent: {
    transition: 'all 0.3s ease-in-out',
    width: '100%',
    overflow: 'hidden',
    position: 'absolute',
    right: 0,
  },
  hideContent: {
    transition: 'all 0.3s ease-in-out',
    transform: 'translateX(110%)',
    overflow: 'hidden',
  },
  hideShowLink: {
    cursor: 'pointer',
  },
  openDataRot: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    letterSpacing: 0.4,
    paddingLeft: 63,
    textAlign: 'left',
    paddingBottom: 10,
    marginTop: -15,
  },
  detailsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  createIconContainer: {
    background: theme.palette.primary.main,
    color: '#fff',
    width: '35px',
    height: '35px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  tableActionContainer: {
    direction: 'rtl',
  },
}));

const TableItem = ({ user }) => {
  const classes = useStyles();
  const history = useHistory();

  // const handleDeleteUser = () => {
  //   dispatch(UsersRequests.removeSingleUser(user._id));
  // };

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell className={clsx(classes.tableCellRoot, classes.tableCellFirst)}>
          <CmtObjectSummary
            avatar={<CmtAvatar src={getProfileImage(user.profileImage)} alt={user.name} color="transparent" />}
            title={user.fullName}
            titleProps={{ className: classes.titleRoot }}
            showItemBadge={false}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            align={'horizontal'}
          />
        </TableCell>
        <TableCell className={clsx(classes.tableCellRoot, classes.tableCellSecond)}>{user.nationalCode}</TableCell>
        <TableCell className={clsx(classes.tableCellRoot, classes.tableCellSecond)}>{user._id}</TableCell>
        <TableCell className={clsx(classes.tableCellRoot, classes.tableActionContainer)}>
          <Box className={classes.createIconContainer} onClick={() => history.push(`/editUser/${user._id}`)}>
            <Create />
          </Box>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default TableItem;
